import { Role } from '@agilox/common';
import { MenuPoint, MenuPointCallbackAction } from '@agilox/ui-common';
import { FleetSubMenuUrl } from '../enums/fleet-submenu.enum';
import { MenuPointUrl } from '../enums/menupoint-url.enum';

/** holds all menupoints */
export const myMenuPoints = {
	dashboard: {
		name: 'menu.dashboard',
		url: MenuPointUrl.DASHBOARD,
		icon: 'dashboard',
		roles: [],
	} as MenuPoint,
	fleet: {
		name: 'menu.fleet',
		url: MenuPointUrl.FLEET,
		icon: 'fleet',
		roles: [],
		submenus: [
			{
				name: 'fleet.submenu.overview',
				url: FleetSubMenuUrl.OVERVIEW,
				roles: [],
			} as MenuPoint,
			{
				name: 'fleet.submenu.technical_data',
				url: FleetSubMenuUrl.TECHNICAL_DATA,
				roles: [],
			} as MenuPoint,
			{
				name: 'fleet.submenu.analysis',
				url: FleetSubMenuUrl.ANALYSIS,
				roles: [Role.superuser, Role.support, Role.service, Role.partner],
			} as MenuPoint,
			{
				name: 'fleet.submenu.telemetry',
				url: FleetSubMenuUrl.TELEMETRY,
				roles: [],
			} as MenuPoint,
			{
				name: 'fleet.submenu.stats',
				url: FleetSubMenuUrl.STATS,
				roles: [Role.superuser, Role.service, Role.partner, Role.support],
			} as MenuPoint,
			{
				name: 'fleet.submenu.details',
				url: FleetSubMenuUrl.DETAILS,
				roles: [],
				hidden: true,
			} as MenuPoint,
			{
				name: 'fleet.submenu.vehicle_history',
				url: FleetSubMenuUrl.VEHICLE_HISTORY,
				roles: [Role.superuser, Role.service, Role.support],
				hidden: true,
			} as MenuPoint,
		],
	},
	release_notes: {
		name: 'menu.release_notes',
		url: MenuPointUrl.RELEASE_NOTES,
		icon: 'news',
		roles: [],
	},
	maas: {
		name: 'menu.maas',
		url: MenuPointUrl.MAAS,
		icon: 'chart_line',
		roles: [],
	},
	settings: {
		name: 'user.account',
		url: MenuPointUrl.SETTINGS,
		icon: 'account',
		roles: [],
		position: 'bottom',
	} as MenuPoint,
	help: {
		name: 'menu.help',
		url: '',
		icon: 'o_quesmark',
		roles: [],
		position: 'bottom',
		callback: true,
		callbackAction: MenuPointCallbackAction.HELP,
	} as MenuPoint,
	logout: {
		name: 'general.logout',
		url: '',
		icon: 'logout',
		roles: [],
		position: 'bottom',
		callback: true,
		callbackAction: MenuPointCallbackAction.LOGOUT,
	} as MenuPoint,
};
